<template>
  <div id="perguntas">
    <div v-for="(item, index) in valorLocal" :key="index">
      <div v-if="!item._destroy" class="item-dinamico-container">
        <div class="item-dinamico-header">
           <div class="item-dinamico-select">
            <v-select
              v-model="item.pergunta_id"
              :options="getOpcoesDePergunta(item)"
              :reduce="(pergunta) => pergunta.id"
              label="texto"
              placeholder="Selecione uma pergunta já cadastrada"
            />
          </div>
          <button type="button" @click="removerPergunta(index)" class="btn-remover">
            <img src="../../assets/imagens/icon-delete-preto.svg" alt="Remover" title="Remover" />
          </button>
        </div>

        <div class="radioContainer">
          <label class="radio-group-label"><b>Tipo de Pergunta:</b></label>
          <div class="radioOption">
            <input type="radio" :id="`tipo-multipla-${index}`" value="multipla_escolha" v-model="item.tipo_pergunta" />
            <label :for="`tipo-multipla-${index}`">Múltipla Escolha</label>
          </div>
          <div class="radioOption">
            <input type="radio" :id="`tipo-unica-${index}`" value="escolha_unica" v-model="item.tipo_pergunta" />
            <label :for="`tipo-unica-${index}`">Escolha Única</label>
          </div>
          <div class="radioOption">
            <input type="radio" :id="`tipo-discursiva-${index}`" value="discursiva" v-model="item.tipo_pergunta" />
            <label :for="`tipo-discursiva-${index}`">Discursiva</label>
          </div>
        </div>

        <div v-if="item.tipo_pergunta === 'multipla_escolha' || item.tipo_pergunta === 'escolha_unica'" class="alternativas-section">
          <div class="itemTop-alternativa">
            <label>Alternativas de Resposta:</label>
            <div class="bt-incluir">
              <button type="button" @click="adicionarAlternativa(item)">
                <span>+</span> Adicionar Alternativa
              </button>
            </div>
          </div>
          
          <div v-for="(alternativa, alt_index) in item.alternativas_attributes" :key="alt_index">
            <div v-if="!alternativa._destroy" class="alternativa-item">
                <v-select
                  class="alternativa-select"
                  v-model="alternativa.resposta"
                  :options="getOpcoesDeResposta(item, alternativa)"
                  label="texto"
                  placeholder="Selecione uma resposta"
                />
                <button type="button" @click="removerAlternativa(item, alt_index)" class="btn-remover-alt">
                  <img src="../../assets/imagens/icon-delete-preto.svg" alt="Remover Alternativa" title="Remover Alternativa" />
                </button>
            </div>
          </div>
          </div>
        </div>
    </div>
    <div class="itemTop">
      <label><strong>Adicionar Pergunta:</strong></label>
      <div class="bt-incluir">
        <button type="button" @click="adicionarPergunta()">
          <span>+</span> Adicionar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, tap } from "lodash";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PerguntaApi from "../../services/PerguntaApi";
import RespostaApi from "../../services/RespostaApi";

export default {
  name: "MultiplasPerguntas",
  props: { value: Array },
  components: { vSelect },
  data() {
    return {
      perguntasDisponiveis: [],
      respostasDisponiveis: [],
    };
  },
  computed: {
    valorLocal() {
      return this.value || [];
    },
  },
  async created() {
    this.perguntaApi = new PerguntaApi();
    this.respostaApi = new RespostaApi();
    await this.carregarPerguntasDisponiveis();
    await this.carregarRespostasDisponiveis();
  },
  methods: {
    async carregarPerguntasDisponiveis() {
      try {
        const data = await this.perguntaApi.getPerguntas({ qtd_por_pagina: 999 });
        this.perguntasDisponiveis = data.resultados;
      } catch (err) {
        console.error("Erro ao carregar perguntas:", err);
      }
    },
    async carregarRespostasDisponiveis() {
      try {
        const data = await this.respostaApi.getRespostas({ qtd_por_pagina: 999 });
        this.respostasDisponiveis = data.resultados;
      } catch (err) {
        console.error("Erro ao carregar respostas:", err);
      }
    },
    adicionarPergunta() {
      this.$emit(
        "input",
        tap(cloneDeep(this.valorLocal), (v) =>
          v.push({
            id: null,
            pergunta_id: null,
            tipo_pergunta: 'discursiva',
            // A linha 'alternativas_attributes' foi removida
            ordem: v.length
          })
        )
      );
    },
    getOpcoesDePergunta(perguntaAtual) {
      // 1. Pega o ID da pergunta que o v-select ATUAL está usando
      const idAtual = perguntaAtual.pergunta_id;

      // 2. Cria um 'Set' (lista) de IDs de pergunta que as OUTRAS
      //    entradas (que não estão destruídas) neste formulário estão usando.
      const idsUsadosPorOutros = new Set();
      this.valorLocal.forEach(p => {
        // Se NÃO for a pergunta atual E tiver um pergunta_id E não estiver destruída...
        if (p !== perguntaAtual && p.pergunta_id && !p._destroy) {
          idsUsadosPorOutros.add(p.pergunta_id);
        }
      });

      // 3. Filtra a lista principal de 'perguntasDisponiveis'
      return this.perguntasDisponiveis.filter(pergunta => {
        // A pergunta deve aparecer na lista se:
        // 1. For a pergunta que este v-select já está usando (idAtual)
        //    OU
        // 2. Não estiver sendo usada por nenhuma outra pergunta (idsUsadosPorOutros)
        return pergunta.id === idAtual || !idsUsadosPorOutros.has(pergunta.id);
      });
    },
    getOpcoesDeResposta(perguntaItem, alternativaAtual) {
      // 1. Pega o ID da resposta que o v-select ATUAL está usando
      const idAtual = alternativaAtual.resposta ? alternativaAtual.resposta.id : null;
      const idsUsadosPorOutros = new Set();
      if (perguntaItem.alternativas_attributes) {
        perguntaItem.alternativas_attributes.forEach(alt => {
          // Se NÃO for a alternativa atual E tiver uma resposta E não estiver destruída...
          if (alt !== alternativaAtual && alt.resposta && !alt._destroy) {
            idsUsadosPorOutros.add(alt.resposta.id);
          }
        });
      }
      return this.respostasDisponiveis.filter(resposta => {
        return resposta.id === idAtual || !idsUsadosPorOutros.has(resposta.id);
      });
    },
    removerPergunta(index) {
      const item = this.valorLocal[index];
      if (item.id) {
        this.$set(this.valorLocal[index], '_destroy', true);
        this.$emit("input", this.valorLocal);
      } else {
        const clone = tap(cloneDeep(this.valorLocal), (v) => v.splice(index, 1));
        this.$emit("input", clone);
      }
    },
    adicionarAlternativa(perguntaItem) {
      if (!perguntaItem.alternativas_attributes) {
        this.$set(perguntaItem, 'alternativas_attributes', []);
      }
      perguntaItem.alternativas_attributes.push({
        id: null,
        resposta: null, // Alterado de resposta_id para resposta
      });
    },
    removerAlternativa(perguntaItem, alternativaIndex) {
      const alternativa = perguntaItem.alternativas_attributes[alternativaIndex];

      if (alternativa.id) {
        // Se a alternativa já existe no banco (tem 'id'),
        // nós a MARCAMOS para destruição (o backend vai deletar)
        this.$set(perguntaItem.alternativas_attributes[alternativaIndex], '_destroy', true);
      
      } else {
        // Se for uma alternativa nova (sem 'id'),
        // nós apenas a REMOVEMOS do array (não precisa ir ao backend)
        perguntaItem.alternativas_attributes.splice(alternativaIndex, 1);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .itemTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .itemTop > label {
    font-size: 0.9rem; 
  }
  
  ::v-deep .item-dinamico-select .vs__dropdown-toggle {
    min-height: 34px; /* Altura menor */
    padding: 2px 8px;
  }
  ::v-deep .item-dinamico-select .vs__search,
  ::v-deep .item-dinamico-select .vs__selected {
    font-size: 0.9rem; /* Fonte menor */
    margin: 2px 0;
    padding: 0;
    color: #000000;
  }
  /* Tamanho da Fonte Tipo de Pergunta */
  .radio-group-label {
    font-weight: bold;
    font-size: 0.9rem;
  }

  /* Tamanho do botão Adicionar Alternativa */
  .itemTop-alternativa .bt-incluir button {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }

  .item-dinamico-container {
    background-color: #e9e9e9;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .item-dinamico-header {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .item-dinamico-select {
    flex-grow: 1;
  }

  .btn-remover img {
    height: 1.5rem;
    cursor: pointer;
  }

  .bt-incluir button {
    padding: 0.5rem 1rem;
  }

  /* Estilos para os Radio Buttons */
  .radioContainer {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-top: 1rem;
    padding-left: 0.5rem;
    border-top: 1px dashed #ccc;
    padding-top: 1rem;
  }

  .radio-group-label {
    font-weight: bold;
  }

  .radioOption {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .radioOption label {
    font-weight: normal;
    margin-bottom: 0;
    cursor: pointer;
    font-size: 0.9rem;
  }

  /* NOVOS ESTILOS PARA A SEÇÃO DE ALTERNATIVAS */
  .alternativas-section {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #ccc;
    padding-left: 1rem;
  }

  .itemTop-alternativa {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .itemTop-alternativa > label {
    font-weight: bold;
    font-size: 0.9rem;
  }
  .alternativa-select {
  flex-grow: 1;
  }

  .alternativa-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.5rem;
  }

  .alternativa-input {
    flex-grow: 1;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .btn-remover-alt img {
    height: 1.2rem;
  }
  .btn-remover-alt {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
</style>